import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function viewMore() {
    return <FontAwesomeIcon icon={faEllipsisV} size="lg" />;
}
